const aboutMeData = {
  headline: 'From a marketing student to a frontend developer',
  story:
    'The chemistry between me and computer sciences established 1 years ago when I was assigned to build a website in the computer network course. I was fascinated at how I could one day use logical codes to express my ideas in a real webpage. After university, I spend everyday to teach myself coding, as well as complete several online courses to gain the skills and knowledge necessary for the tech industry.',
  skillsets:
    "I've been learning and practicing from data structures and algorithm, to JavaScript, TypeScript, and how to utilize different modern libraries and frameworks such as React.js, Vue.js, Redux, Vuex and Node.js.",
  objective:
    ' Now I am excited to take my passion to the next level and pursue a career in frontend development, where I can use my  problem-solving, collaboration and communication skills to create meaningful and user-friendly applications.',
};

export default aboutMeData;
